export function addThousandsSeparator(number, decimals = 0, separator = ',') {
  if (typeof number.toString !== 'function') return number;

  const value = number.toString();

  if (!value) return number;

  let [whole, decimal] = value.split('.');
  whole = whole.replace(/\B(?=(\d{3})+(?!\d))/g, separator);
  decimal = decimals && decimal ? `.${decimal.substr(0, decimals)}` : '';

  return `${whole}${decimal}`;
}
